import type { CSSProperties } from 'react';

export const planCountStyle: CSSProperties = {
  fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
  fontWeight: 400,
  fontSize: '0.875rem',
  lineHeight: '1.43em',
  color: '#333333',
};

export const searchFieldStyle: CSSProperties = {
  width: '15rem',
  height: '2rem',
};

export const actionButtonsContainerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem',
  width: '100%',
  height: '100%',
};

export const cellTextStyle: CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const noDescriptionStyle: CSSProperties = {
  ...cellTextStyle,
  color: '#636E70',
};

export const linkCellStyle: CSSProperties = {
  color: '#1162EE',
  cursor: 'pointer',
};

export const skeletonContainerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0',
  background: '#fff',
  borderRadius: '0.5rem',
  overflow: 'hidden',
  border: '0.0625rem solid #e8ebf0',
};

/** Full-width card area with centered Neon loading indicator (initial load + filter apply). */
export const plansOfStudyLoadingContainerStyle: CSSProperties = {
  ...skeletonContainerStyle,
  minHeight: '16rem',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '3rem 1.5rem',
  boxSizing: 'border-box',
};

export const skeletonHeaderStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  padding: '0.875rem 1rem',
  borderBottom: '0.0625rem solid #e8ebf0',
};

export const skeletonRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  padding: '0.875rem 1rem',
  borderBottom: '0.0625rem solid #f3f6fb',
};

export const skeletonBarStyle = (width: string): CSSProperties => ({
  height: '0.875rem',
  width,
  borderRadius: '0.25rem',
  background: 'linear-gradient(90deg, #e8ebf0 25%, #f3f6fb 50%, #e8ebf0 75%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 1.5s ease-in-out infinite',
});
